<script>
    import {onMount} from 'svelte';
    import {useMachine} from '@xstate/svelte';
    import {createMachine} from 'xstate';
    import {mainMachine} from './machine';
    import * as google from './google';
    import Quagga from './quagga-1.3.1';

    const machine = createMachine(mainMachine, {
      actions: {
        createQuagga: function() {
            Quagga.init({
                inputStream: {
                    name: "Live",
                    type: "LiveStream",
                    constraints: {
                        width: {min:640},
                        height: {min:480},
                        facingMode: "environment",
                        aspectRatio: {min:1,max:2},
                    },
                    target: document.querySelector("#stream-view"),
                },
                frequency: 2,
                decoder: {
                    readers: ['ean_reader'],
                },
            }, function(err) {
                if (err) {
                    console.log("Quagga error", err);
                    send('ERROR');
                    return;
                }

                console.log("Quagga initialized");
                Quagga.onDetected((result) => {
                    console.log("DETECTED", result);
                    send({ type: 'ISBN_ENTERED', isbn: result.codeResult.code });
                });
                send('INITIALIZED');
            });
        },
        startScanning: Quagga.start,
        stopScanning: Quagga.stop,
    },
    services: {
        processISBN: function(context) {
            console.log("processing ISBN", context.isbn);
            return google.loadBookFromISBN(context.isbn).then((result) => {
                console.log("FOUND BOOK", result);
                return result; 
            }).then((book) => { return google.logToSpreadsheet($state.context.email, book) })
        },
      },
    });
    const { state, send } = useMachine(machine);
    let isbn_input;

    window.setupGAPI = function() {
      google.init((email) => {
        if (email) {
            send({ type: 'SIGNED_IN', email: email });
        } else {
            send('SIGNED_OUT');
        }
      });
    };
</script>

<svelte:head>
    <title>Book tracker</title>
    <script src="https://apis.google.com/js/platform.js?onload=setupGAPI" async defer></script>
</svelte:head>

<style>
.hidden {
    display: none;
}
</style>

{#if $state.matches('signed_out') }
  <button on:click={() => google.signIn()}>Sign in</button>
{:else}
  <h3>{$state.context.email}</h3>
  <button on:click={() => google.signOut()}>Sign out</button>
{/if}

{#if $state.context.isbn}
<h2>Current ISBN: {$state.context.isbn}</h2>
{/if}

{#if $state.matches('signed_in.error') || $state.matches('signed_in.success')}
<h2>{$state.context.message}</h2>
<button on:click={() => send('REPEAT')}>Again</button>
{/if}

<div class:hidden="{!$state.matches('signed_in.wait_for_input')}">
    <div id="stream-view" />
    <form on:submit|preventDefault={() => send({ type: 'ISBN_ENTERED', isbn: isbn_input })}>
        <label>ISBN:</label>
        <input type="text" bind:value={isbn_input} />
        <button type="submit">Submit</button>
    </form>
</div>
